import React, { useState } from 'react';

import {
	CourseEntity,
	ICourseEntityAttributes,
} from 'Models/Entities';

import CourseInfoModal from 'Views/Pages/Frontend/StudyPlanWizard/CourseInfoModal';
import { Conditional } from 'Views/Components/Conditional/Conditional';
import InfoIconButton from '../InfoIconButton/InfoIconButton';
import { toLower } from 'lodash';

interface AccordionItemProps {
	course: ICourseEntityAttributes;
	index: number;
	label?: React.ReactNode;
	warning?: React.ReactNode
	additionalStatus?: React.ReactNode;
}

interface IComponentList {
	label: React.ReactNode
}

const ComponentList = (props: IComponentList) => {
	const { label } = props;
	return (
		<div className="course-component-list">
			{label}
		</div>
	);
};

const CourseAccordionItem = (props: AccordionItemProps) => {
	const {
		course,
		label,
		warning,
		additionalStatus,
	} = props;

	const [showCourseInfoModal, setShowCourseInfoModal] = useState(false);

	const topLevelLogicGroup = course.requisiteLogicGroups
		.find(logicGroup => logicGroup.isTopLevelGroup);

	// show requisite description if there's no requisite warnings
	const requisiteDescription = !warning && topLevelLogicGroup?.description?.length
		? (
			<div className="requisite-description">
				{topLevelLogicGroup?.description}
			</div>
		)
		: null;

	const courseEntity = new CourseEntity(course);

	return (
		<div className="course-accordion-list-item">
			<div className="course-details">
				<div className="course-name">
					<p>
						{course.code}
						{' '}
						<span className="txt-bold">
							{courseEntity.getDisplayName()}
						</span>
					</p>
					{requisiteDescription}
				</div>
				<Conditional<IComponentList>
					condition={label}
					component={ComponentList}
					componentProps={{ key: 'component-list', label }}
				/>
				<span className="additional-status">
					{additionalStatus}
				</span>
				<div className="course-units">
					<InfoIconButton
						ariaLabel={`${new CourseEntity(course).getDisplayName()}`}
						onClick={() => setShowCourseInfoModal(true)}
					/>
					<p className="units">{course.units} {toLower(window.lexicon.unitsShort)}</p>
				</div>
			</div>
			{warning ? (
				<div className="course-warning">
					{warning}
				</div>
			) : null}
			{
				showCourseInfoModal && course.id
					? (
						<CourseInfoModal
							isOpen={showCourseInfoModal}
							courseId={course.id}
							onCloseModal={() => setShowCourseInfoModal(false)}
						/>
					)
					: null
			}
		</div>
	);
};

export default CourseAccordionItem;
